import axios from 'axios'
import baseurl from './baseURL'





axios.interceptors.request.use(function (config) {
    
    if(config.url == "/rfid/read" || config.url =="/rfid/write"){
        config.url
    }else{
       config.url = baseurl + config.url
    }
    config.headers['Cache-Control'] = 'no-cache'
    // config.url =baseurl+ config.url 
    config.headers.Authorization = window.sessionStorage.getItem('token')
    // console.log(config)
    return config
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
      return response
}, function (error) {
    console.log(error);
    // 对响应错误做点什么
    return Promise.reject(error)
});


// WEBPACK FOOTER //
// ./src/utils/http.js